import { IData } from 'my-poppies-b2b-types';
import { sleep } from 'sleep-lightweight';

import { dummyDataData } from '@/dummyData/dummyDataData';

export const mockApiCallForData = async (): Promise<IData> => {
  await sleep(250);
  return dummyDataData;
};
